import { handleActions } from "redux-actions";
import FilterOptions from "collections/filters"; // TODO: move to immutable

import {
    ITEMS_FAILURE,
    ITEMS_FILTER_CHANGE,
    ITEMS_FILTER_OPTIONS_FAILURE,
    ITEMS_FILTER_OPTIONS_REQUEST,
    ITEMS_FILTER_OPTIONS_SUCCESS,
    ITEMS_REQUEST_START,
    ITEMS_RESET,
    ITEMS_RESULT,
    ITEMS_SEARCH_CHANGE,
} from "constants/action-types";

const initialState = {
    result: [],
    isFetching: false,
    error: undefined,
    nextPage: undefined,
    hasMoreResults: false,
    filterOptions: new FilterOptions(),
    filterOptionsIsFetching: false,
    filterOptionsError: undefined,
    filters: undefined,
    unmounted: true,
};

const catalogReducer = handleActions(
    {
        [ITEMS_REQUEST_START]: (state, { payload = {} }) => {
            return Object.assign({}, state, {
                result: payload.reset ? [] : state.result,
                isFetching: true,
                nextPage: undefined,
                hasMoreResults: false,
            });
        },
        [ITEMS_RESULT]: (state, { payload, meta }) => {
            let result;
            if (meta.replace) {
                result = payload;
            } else {
                result = state.result.concat(payload);
            }
            return Object.assign({}, state, {
                result,
                nextPage: meta.next,
                hasMoreResults: !!meta.next,
                isFetching: false,
            });
        },
        [ITEMS_FAILURE]: (state, { payload, error }) => {
            const { nextPage } = state;
            return Object.assign({}, state, {
                isFetching: false,
                error: error ? payload : undefined,
                hasMoreResults: !!nextPage,
            });
        },
        [ITEMS_SEARCH_CHANGE]: (state, { search }) => {
            return Object.assign({}, state, { search });
        },
        [ITEMS_FILTER_CHANGE]: (state, { filters }) => {
            return Object.assign({}, state, { filters, unmounted: false });
        },
        [ITEMS_FILTER_OPTIONS_REQUEST]: (state) => {
            return Object.assign({}, state, {
                filterOptionsError: undefined,
                filterOptions: initialState.filterOptions,
                filterOptionsIsFetching: true,
            });
        },
        [ITEMS_FILTER_OPTIONS_SUCCESS]: (state, { data }) => {
            return Object.assign({}, state, {
                filterOptions: new FilterOptions(data),
                filterOptionsIsFetching: false,
            });
        },
        [ITEMS_FILTER_OPTIONS_FAILURE]: (state, error) => {
            return Object.assign({}, state, {
                filterOptionsError: error,
                filterOptionsIsFetching: false,
            });
        },
        [ITEMS_RESET]: () => {
            return initialState;
        },
    },
    initialState
);

export default catalogReducer;
